module.exports = __webpack_public_path__ + "assets/img/not_data_tips-1a5471b2.png";